import { useTranslation } from "gatsby-plugin-react-i18next";
import { compact } from "lodash";
import type { FC } from "react";
import Button from "../../../components/general/Button";
import MaterialListItem from "../../../components/general/Modal/components/MaterialListItem";
import type { Material } from "../../../utils/materials";

type MaterialComponentProps = {
	materials?: Material[];
};

export const Materials: FC<MaterialComponentProps> = ({ materials }) => {
	const { t } = useTranslation();
	const fabricItems = compact(
		materials?.map(({ material, url, selected }) =>
			(material?.description || material?.bullets) &&
			material.name &&
			material.image?.filename
				? {
						fabric: material.name,
						image: {
							src: material.image.filename,
							alt: material.image.alt ?? undefined,
						},
						description: material.description,
						bullets: material.bullets,
						button: url ? (
							selected ? (
								<Button label={t("Chosen")} variant="secondary"></Button>
							) : (
								<Button href={url} label={t("Choose")} variant="primary" />
							)
						) : undefined,
					}
				: undefined,
		),
	);

	return <MaterialListItem fabrics={fabricItems} />;
};
